module.exports = __webpack_public_path__ + "257da663af087238640febb6e732c965.svg";